import React, { Component } from 'react';
import { Redirect } from 'react-router';
import { Link } from 'react-router-dom';
import { isMobile } from 'react-device-detect';
import yaml from 'js-yaml';
import Fade from 'react-reveal/Fade';
import Flash from 'react-reveal/Flash';

import { setCookie, getCookie } from '../utils/cookie_utils.js'

import Navbar from '../components/Navbar'
import Footer from '../components/Footer'

import '../css/SolutionPage.css';

class SolutionPage extends Component {
  constructor(props) {
    var lang = "zh"
    if (getCookie("lang") !== "") {
      lang = getCookie("lang")
    }

    super(props);
    this.state = {
      lang: lang,
      card_display: "v2_display_none",
      current_cat: "id1",
      card_content: null,
      content: [],
      category: {}
    }

    this.general_switch_page = this.general_switch_page.bind(this)
    this.update_lang = this.update_lang.bind(this)
    this.update_card_status = this.update_card_status.bind(this)
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.lang !== this.state.lang) {
      this.setState({ lang: nextProps.lang });
    }
  }

  componentDidMount() {
    fetch(process.env.PUBLIC_URL + '/yaml/custom_product_info.yaml')
    .then(response => response.text())
    .then(text => {
      const parsed = yaml.load(text);
      console.log(parsed)
      this.setState({ content: parsed.content, category: parsed.category });
    });
  }

  update_lang(current_lang) {
    this.setState({
      lang: current_lang
    }, () => {
      console.log(this.state.lang)
    })
  }

  update_card_status(status, _data, img) {
    if (status === "open") {
      this.setState({
        card_display: "",
        card_content: { ..._data, "img_url": img}
      })
    }
    else {
      this.setState({
        card_display: "v2_display_none",
        card_content: null
      })
    }
  }

  general_switch_page(path, data) {
    if (path !== "/SolutionPage" || path !== "/") {
      setCookie("lang", this.state.lang)
      window.location.href = path + "?page=" + data
    }
    else {
      // pass
    }
  }

  sort_func(_id) {
    this.setState({
      current_cat: _id
    })
  }


  render() {
        return (
          <div className={this.state.lang+" solution_page"} >
            <Navbar lang={this.state.lang} updateLangFunc={this.update_lang} />
            {this.state.category.title && this.state.category.content ? <SolutionNavBar lang={this.state.lang} title={this.state.category.title} content={this.state.category.content} sort_func={(_id) => {this.sort_func(_id)}}/> : <></>}
            {this.state.content.map(item => 
              (item["title"]["group_tag"].includes(this.state.current_cat) ? <SolutionSection lang={this.state.lang} title={item["title"]} content={item["content"]} update_card_status={this.update_card_status} current_cat={this.state.current_cat}/> : <></>))}
            <PopupCard className={this.state.card_display} card_content={this.state.card_content} update_card_status={this.update_card_status}/>
            <Footer lang={this.state.lang} general_switch_page={this.general_switch_page}/>
          </div>
        ) 
  }

}

class SolutionNavBar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      lang: this.props.lang,
      title: this.props.title,
      content: this.props.content
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.lang !== this.state.lang) {
      this.setState({ lang: nextProps.lang });
    }
  }

  nav_btn_function(_id) {
    this.props.sort_func(_id)
  }

  render() {
    return (
      <div className="solution_nav_section">
        <p className="nav_btn_title">{this.state.title[this.state.lang]}</p>
        <div className="nav_section_holder">
          {this.state.content.map((item) => <div className="nav_btn" onClick={() => {this.nav_btn_function(item["id"])}}>{item[this.state.lang]}</div>)}
        </div>
      </div>
    )
  }
}


class SolutionSection extends Component {
  constructor(props) {
    super(props);
    this.state = {
      lang: this.props.lang,
      title: this.props.title,
      content: this.props.content,
      current_cat: this.props.current_cat
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.lang !== this.state.lang) {
      this.setState({ lang: nextProps.lang });
    }
    if (nextProps.current_cat !== this.state.current_cat) {
      this.setState({ current_cat: nextProps.current_cat });
    }
  }

  render() {
    return (
      <>
        <div className="solution_title_section">
          <h2 style={{color: this.state.title["color"]}} >{this.state.title[this.state.lang]}</h2>
        </div>
        <div className="solution_section">
          {this.state.content.map((item) => (item["group_tag"].includes(this.state.current_cat) ? <SolutionCard color={this.state.title["color"]} lang={this.state.lang} img_url={item["img_url"]} content={item} onClick={() => this.props.update_card_status("open", item["detail_content"][this.state.lang], item["img_url"])}/> : <></>))}
        </div>
      </>
    )
  }
}


class SolutionCard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      lang: this.props.lang,
      name: this.props.content,
      img_url: this.props.img_url !== "" ? this.props.img_url : "/assets/mainpage_home1.webp",
      status: "DETAIL"
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.lang !== this.state.lang) {
      this.setState({ lang: nextProps.lang });
    }
  }

  render() {
    return (
      <div className="solution_card" onClick={this.props.onClick}>
        <div className="img_section" style={{backgroundColor: this.props.color}}>
          <img src={this.state.img_url} />
        </div>
        <div className="solution_card_info">
          <h2>{this.state.name[this.state.lang]}</h2>
          <span>{this.state.status} ></span>
        </div>
      </div>
    )
  }
}

class PopupCard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      lang: this.props.lang,
      status: "DETAIL",
      card_content: this.props.card_content,
      card_flag: true
    }

    console.log("this.props.card_content: ", this.props.card_content)
    this.closeWin = React.createRef();
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.lang !== this.state.lang) {
      this.setState({ lang: nextProps.lang });
    }
    else if (nextProps.card_content !== this.state.card_content) {
      this.setState({ card_content: nextProps.card_content });
    }
  }

  render() {
    return (
      <div className={"v2_solution_pop_up_bg "+this.props.className} onClick={() => {this.state.card_flag ? this.props.update_card_status("close") : this.setState({card_flag: true})}}>
        <div className="v2_solution_pop_up_card" onClick={() => this.state.card_flag = false}>
          <div className="v2_solution_pop_up_card_img_section">
            <img src={this.state.card_content ? this.state.card_content["img_url"] : "https://images.unsplash.com/photo-1522770179533-24471fcdba45"} />
            <div className="v2_solution_pop_up_card_info_title">
              <h1>{this.state.card_content ? this.state.card_content["title"] : ""}</h1>
            </div>
            <div className="v2_solution_pop_up_card_info_section1">
              {this.state.card_content && this.state.card_content["subl1"].length > 0 ? 
              <div className="v2_pop_info_section1_list_holder">
                <h2>{this.state.card_content ? this.state.card_content["subt1"] : ""}</h2>
                <hr />
                <div className="v2_pop_info_section1_list">
                  {this.state.card_content ? this.state.card_content["subl1"].map(item => 

                    <div className="v2_pop_info_section1_list_item">
                      <span className="v2_cube"></span>
                      <p>{item}</p>
                    </div>)

                   : <></>}
                </div>
              </div> : <></>}
              {this.state.card_content && this.state.card_content["subl2"].length > 0 ? 
              <div className="v2_pop_info_section1_list_holder">
                <h2>{this.state.card_content ? this.state.card_content["subt2"] : ""}</h2>
                <hr />
                <div className="v2_pop_info_section1_list">

                  {this.state.card_content ? this.state.card_content["subl2"].map(item => 

                    <div className="v2_pop_info_section1_list_item">
                      <span className="v2_cube"></span>
                      <p>{item}</p>
                    </div>)

                   : <></>}
                  
                </div>
              </div> : <></>}
            </div>
          </div>
          <div className="v2_solution_pop_up_card_info_section2">
            <div className="v2_solution_pop_up_card_main_info">
              <h3>{this.state.card_content ? this.state.card_content["subt3"] : ""}</h3>
              <p dangerouslySetInnerHTML={{ __html: this.state.card_content ? this.state.card_content["subc3"] : "" }}></p>
              <br/>
              <h3>{this.state.card_content ? this.state.card_content["subt4"] : ""}</h3>
              <p dangerouslySetInnerHTML={{ __html: this.state.card_content ? this.state.card_content["subc4"] : "" }}></p>
            </div>
            {/*<div className="v2_solution_pop_up_card_btn_section"></div>*/}
            <button className="v2_solution_pop_up_card_close" onClick={() => this.props.update_card_status("close")}>x</button>
          </div>
        </div>
      </div>
    )
  }
}

export default SolutionPage;













